import { Component, EventEmitter, OnInit, Output, forwardRef } from '@angular/core';
import { ControlContainer, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SmUiComponent } from '../sm-ui/sm-ui.component';

@Component({
    selector: 'sm-radio',
    templateUrl: './sm-radio.component.html',
    styleUrls: ['./sm-radio.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SmRadioComponent),
            multi: true
        }
    ]
})
export class SmRadioComponent extends SmUiComponent implements OnInit {
    @Output() checked = new EventEmitter<any>();

    checkboxEmitter(event,option): void {
        
        this.checked.emit({ val: event.target.value,key:option.key});
    }

    override ngOnInit(): void {
        super.ngOnInit();
    }

}
